<div class="page-container">
  <div *ngFor="let title of titles; let i = index">
    <app-chart [index]="i" [data]="reportData | filterReportDataByTitle: title" [chartType]="'line'"></app-chart>
  </div>
</div>